import { Link } from 'react-router-dom';
import SeoHead from '@/components/feature/SeoHead';
import { allArticles } from '@/mocks/categories';

export default function Articles() {
  useEffect(() => {
    const script = document.createElement('script');
    script.id = 'schema-breadcrumb-articles';
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: '首页', item: 'https://jiuyou.com' },
        { '@type': 'ListItem', position: 2, name: '文章', item: 'https://jiuyou.com/articles' },
      ],
    });
    document.head.appendChild(script);
    return () => {
      const s = document.getElementById('schema-breadcrumb-articles');
      if (s) s.remove();
    };
  }, []);

  return (
    <>
      <SeoHead
        data={{
          title: '文章列表 - jiuyou平台教程、优惠与评价 | jiuyou官网',
          description: 'jiuyou平台最新文章汇总，涵盖使用教程、优惠活动、用户评价等丰富内容，助您全面了解jiuyou的各项功能与服务。',
          canonicalUrl: 'https://jiuyou.com/articles',
        }}
      />

      <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-10">
            <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
              最新文章
            </h1>
            <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              了解jiuyou的最新动态、使用技巧与用户故事
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {allArticles.map((article, index) => (
              <Link
                key={article.id}
                to={`/articles/${article.slug}`}
                className="group p-6 rounded-2xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300"
              >
                <span className="inline-block px-3 py-1 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-4">
                  {article.categoryName}
                </span>
                <h2 className="text-lg font-heading font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors mb-3">
                  {article.title}
                </h2>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4 line-clamp-2">{article.summary}</p>
                <div className="flex items-center gap-4 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line" />
                    {article.date}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line" />
                    {article.readTime}
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}